import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { GlycerinRatingStatus, type GlycerinDisplayProductPayload } from '@packages/tracking';

const GetGlycerinRatingStatusFragment = graphql(/* GraphQL */ `
  fragment GetGlycerinRatingStatusFragment on RatingResult {
    product {
      avgRating
      reviewCount
    }
  }
`);

export type GetGlycerinRatingStatusProps = FragmentType<
  typeof GetGlycerinRatingStatusFragment
> | null;
export type GetGlycerinRatingStatusReturn = Pick<
  GlycerinDisplayProductPayload,
  'ratingStatus' | 'rating' | 'ratingCount'
>;

export const getGlycerinRatingStatus = (
  data: GetGlycerinRatingStatusProps,
): GetGlycerinRatingStatusReturn => {
  if (!data) return { ratingStatus: GlycerinRatingStatus.UNAVAILABLE };

  const { product } = getFragmentData(GetGlycerinRatingStatusFragment, data);

  if (!product) return { ratingStatus: GlycerinRatingStatus.UNAVAILABLE };

  // map rating to glycerin enum names
  if (product.reviewCount > 0) {
    return {
      ratingStatus: GlycerinRatingStatus.RATED,
      // optional rating fields if product has been rated
      rating: product.avgRating,
      ratingCount: product.reviewCount,
    };
  }

  return {
    ratingStatus: GlycerinRatingStatus.UNRATED,
  };
};
